"use client";

import { AccountIcon } from "@/components/icons/Account";
import { useTranslations } from "@/i18n/client";
import { useAuth } from "@/lib/centra/hooks/useAuth";
import clsx from "clsx";
import Button from "../Button";
import styles from "./index.module.css";

export const AccountItem = () => {
  const { isLoggedIn } = useAuth();
  const t = useTranslations();

  if (isLoggedIn)
    return (
      <Button
        mode="unset"
        className={clsx(styles.item, styles.navbarLinks)}
        href="/account"
      >
        <p className={styles.linksDesktop}>{t("megaMenu.myPage")}</p>
        <span className={styles.linksMobile}>
          <AccountIcon />
        </span>
      </Button>
    );

  return (
    <Button
      mode="unset"
      className={clsx(styles.item, styles.navbarLinks)}
      modal={"login"}
    >
      <p className={styles.linksDesktop}>{t("megaMenu.myPage")}</p>
      <span className={styles.linksMobile}>
        <AccountIcon />
      </span>
    </Button>
  );
};
